import { render, staticRenderFns } from "./PersonalPhoto.vue?vue&type=template&id=6beef416&scoped=true"
import script from "./PersonalPhoto.vue?vue&type=script&lang=js"
export * from "./PersonalPhoto.vue?vue&type=script&lang=js"
import style0 from "./PersonalPhoto.vue?vue&type=style&index=0&id=6beef416&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6beef416",
  null
  
)

export default component.exports